var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("a", [
      _c("span", [_vm._v("Unable to submit some events. Please check for")]),
      _c("br"),
      _vm._v(" "),
      _c("ul", [
        _c("br"),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "Incomplete information. Please fill in required information and continue submitting"
          )
        ]),
        _c("br"),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "Events requested within 90 days. Normal event scheduling requires advanced notice of 90 days. Please choose dates that meet these requirements or contact ADURO for assistance."
          )
        ])
      ]),
      _vm._v(" "),
      _c("span", { staticClass: "modal-body-text" }, [
        _vm._v("All completed events have been submitted.")
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-55c4af48", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-55c4af48","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/modal/SubmitAllEventEmptyFieldsAnd90DaysError.vue
// module id = 1400
// module chunks = 1